// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.4004 8.75781L13.4512 17.707L8.63086 22.5439L1.75293 15.667L15.5312 1.88867L22.4004 8.75781ZM4.58203 15.666L8.62793 19.7119L11.3291 17L7.28809 12.959L4.58203 15.666Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13V20H22V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 18H18V16H22V18Z"}}]};

const CorrectFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'correct-filled',
    ref,
    icon: element,
  },
));

CorrectFilledIcon.displayName = 'CorrectFilledIcon';

export default CorrectFilledIcon;
